import { snakeCase } from 'lodash';

export const getActionType = (actionName, moduleName = 'LOGIN_METHODS') =>
  `${moduleName}/${snakeCase(actionName).toUpperCase()}`;

export const createActionCreator = actionName => payload => ({
  type: getActionType(actionName),
  ...payload,
});
